interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = 'https://naipiananime.com',
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const fullTitle = title ? `${title} | 奶片动漫` : '奶片动漫 - 正版动漫在线观看平台 | 热门新番高清追番';
  const fullDesc = description || '奶片动漫是你的专属动漫追番基地，涵盖热门新番、经典老番、国漫、日漫等海量资源，高清流畅播放，支持弹幕互动。';
  const fullKeywords = keywords || '奶片动漫,动漫在线观看,最新番剧,国漫推荐,高清播放';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="奶片动漫" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </>
  );
}